import { CancelTokenSource } from 'axios';
import { IBookmark, INotifications, IUser, IUserUpdate, UserNotificationLabels } from '../types';
import { ApiRepository } from './main repository/api.repository';

export namespace UserService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/users`;

  export const getUser = async (cancelTokenSource: CancelTokenSource): Promise<IUser> => {
    return ApiRepository.Core().get(`${BASE_API}/me`, undefined, {
      cancelToken: cancelTokenSource.token,
    });
  };

  export const getUsers = async (cancelTokenSource: CancelTokenSource, ids: number[]): Promise<IUser[]> => {
    return ApiRepository.Core().get(BASE_API, { ids: ids.join(',') }, { cancelToken: cancelTokenSource.token });
  };

  export const updateAllUsers = async (cancelTokenSource: CancelTokenSource, data: IUserUpdate): Promise<IUser[]> => {
    return ApiRepository.Core().put(BASE_API, data, undefined, {
      cancelToken: cancelTokenSource.token,
    });
  };

  export const updateUser = async (
    cancelTokenSource: CancelTokenSource,
    userId: number | undefined,
    data: IUserUpdate
  ): Promise<IUser> => {
    return ApiRepository.Core().put(`${BASE_API}/${userId}`, data, undefined, {
      cancelToken: cancelTokenSource.token,
    });
  };

  export const getUserBookmarks = async (
    cancelTokenSource: CancelTokenSource,
    userId: number
  ): Promise<IBookmark[]> => {
    return ApiRepository.Core().get(`${BASE_API}/${userId}/bookmarks`, undefined, {
      cancelToken: cancelTokenSource.token,
    });
  };

  export const getMyNotifications = async (
    cancelTokenSource: CancelTokenSource,
    applicationIds: number[],
    recordFrom: string,
    recordTo: string
  ): Promise<INotifications[]> => {
    return ApiRepository.Core().get(
      `${BASE_API}/notifications`,
      { recordFrom, recordTo, applicationIds: applicationIds.join(',') },
      { cancelToken: cancelTokenSource.token }
    );
  };

  export const getUserNotificationLabels = async (): Promise<UserNotificationLabels> => {
    return ApiRepository.Core().get(`${BASE_API}/notification-labels`);
  };
}
